module.exports = __webpack_public_path__ + "assets/img/00103.9420f2d4.png";